import { render, staticRenderFns } from "./ReservaDetalheSidebar.vue?vue&type=template&id=5c31f11d"
import script from "./ReservaDetalheSidebar.vue?vue&type=script&lang=js"
export * from "./ReservaDetalheSidebar.vue?vue&type=script&lang=js"
import style0 from "./ReservaDetalheSidebar.vue?vue&type=style&index=0&id=5c31f11d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports